<app-header [forceLightBackground]="true"></app-header>
<div class="delegate-page">
  <div class="delegate-page--layout">
    <app-provider-sidebar class="delegate-page--sidebar"></app-provider-sidebar>
    <div class="delegate-page--content">
      <app-page-header></app-page-header>
      <div class="delegate-container">
        <lib-manage-delegates
          tabStorageScope="provider"
          [ownersOnly]="ownersOnly"
          [activeOwnerId]="activeDelegatedOwnerId"
          [scopeOptions]="providerScopeOptions"
          (addDelegate)="onDelegateCreated()"
          (deleteDelegate)="onDelegateDeleted()"
          (withdrawOwner)="onAccessRevoked($event)"
          (switchOwner)="onSwitchOwner($event)"
          (requestOwner)="onRequestOwner($event)"
        ></lib-manage-delegates>
      </div>
    </div>
  </div>
</div>
